module.exports = __webpack_public_path__ + "img/group-invite.dfd69be.svg";